"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logo = _interopRequireDefault(require("../assets/svg/logo.svg"));

var _logoIcon = _interopRequireDefault(require("../assets/svg/logo-icon.svg"));

require("./Logo.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var renderLogoImg = function renderLogoImg(icon, props) {
  return _react.default.createElement("img", _extends({
    src: icon ? _logoIcon.default : _logo.default,
    alt: "Yapay",
    className: "logo__img"
  }, props));
};

var Logo = function Logo(_ref) {
  var icon = _ref.icon,
      to = _ref.to,
      color = _ref.color,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["icon", "to", "color", "onClick"]);

  var wrapperClass = 'logo';

  if (color === 'white') {
    wrapperClass += ' logo--white';
  }

  if (to) {
    wrapperClass += ' logo--link';
    return _react.default.createElement("div", {
      className: wrapperClass,
      onClick: function onClick() {
        return _onClick(to);
      }
    }, renderLogoImg(icon));
  }

  return _react.default.createElement("div", {
    className: wrapperClass
  }, renderLogoImg(icon, props));
};

Logo.defaultProps = {
  color: null,
  to: null,
  onClick: function onClick() {}
};
renderLogoImg.defaultProps = {
  icon: null
};
Logo.propTypes = {
  /** Callback executado após clicar no logo */
  onClick: _propTypes.default.func,

  /** Define se o logo terá link */
  to: _propTypes.default.string,

  /** Define o tipo de exibição do logo */
  icon: _propTypes.default.bool
};
var _default = Logo;
exports.default = _default;